import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";

type ProtectedRouteProps = {
  children: React.ReactNode | (({ user }: { user: any }) => React.ReactNode);
  allowedRoles?: string[];
};

export default function ProtectedRoute({
  children,
  allowedRoles,
}: ProtectedRouteProps) {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    if (user.role === "NURSE") {
      return <Navigate to="/nurse-dashboard" replace />;
    }
    if (user.role === "SCHOOL_HEAD") {
      return <Navigate to="/school-head/dashboard" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  if (typeof children === "function") {
    return <>{children({ user })}</>;
  }

  return <>{children}</>;
}